import memoize from 'memoizee';
import { flattenArray } from '@/utils/Array';
import Request from '@/utils/Request';

const CURVE_REGISTRIES = ['main', 'crypto', 'factory', 'factory-crypto'];

const getAllCurvePoolsData = memoize(async (blockchainId) => {
  const allPools = flattenArray(await Promise.all(CURVE_REGISTRIES.map(async (registryId) => (
    (await (await Request.get(`https://api.curve.fi/api/getPools/${blockchainId}/${registryId}`)).json()).data.poolData
      .map((pool) => ({
        ...pool,
        registryId,
      }))
  ))));

  return allPools;
}, {
  promise: true,
  maxAge: 60 * 1000, // 60s
});

export default getAllCurvePoolsData;
